import { useLayoutEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useSiteTheme } from './SiteTheme';

export default function NavigationThemeSwitch({ mobile = false, circular = false }) {
  const state = useSiteTheme();
  const claim = state?.claimThemeControl;
  const forced = state?.themeForced;
  // One owner covers both responsive presentations. Keep the fallback control
  // available for standalone shells, and leave forced-theme previews untouched.
  useLayoutEffect(() => {
    if (!mobile && !forced) return claim?.();
    return undefined;
  }, [claim, mobile, forced]);
  if (!state || forced) return null;
  const dark = state.theme === 'dark';
  if (circular) return <button type="button" className="site-navigation-theme-circle" role="switch" aria-label="Dark mode" aria-checked={dark}
    title={dark ? 'Switch to light mode' : 'Switch to dark mode'} onClick={() => state.select(dark ? 'light' : 'dark')}>
    {dark ? <Sun size={21} strokeWidth={1.5} aria-hidden="true" /> : <Moon size={21} strokeWidth={1.5} aria-hidden="true" />}
  </button>;
  return <div className={mobile ? 'site-navigation-appearance' : 'site-navigation-theme'}>
    {mobile && <span>Appearance</span>}
    <button type="button" role="switch" aria-label="Dark mode" aria-checked={dark}
      onClick={() => state.select(dark ? 'light' : 'dark')}>
      <span className="site-navigation-theme-track" aria-hidden="true">
        <Sun size={13} /><Moon size={13} /><span className="site-navigation-theme-thumb" />
      </span>
    </button>
  </div>;
}
